// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'undock';

export const Component = () => (
  <path d='M11.492 13.5a1 1 0 0 1 0 1.414L6.406 20H10.5a1 1 0 0 1 0 2H3v-7.5a1 1 0 0 1 2 0v4.078l5.078-5.078a1 1 0 0 1 1.414 0ZM22 3v7.5a1 1 0 0 1-2 0V6.32l-5.179 5.18a1 1 0 0 1-1.414-1.414L18.492 5H14.5a1 1 0 0 1 0-2H22Z' />
);

export const viewBox = '0 0 25 25';
